<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ getPanelTitle() }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <p class="panel-description" *ngIf="props.description">{{ props.description }}</p>
  <ng-container #fieldComponent></ng-container>
</mat-expansion-panel>
